<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>La caída de Tenochtitlán. 1521</h2>
    <img @click="imageClicked(0)" src="galerias/tenochtitlan/g6/g6.jpg" class="mainphoto"/>
    <p class="photo-description">Fragmento del Lienzo de Tlaxcala. Acuarela sobre papel europeo copiado en el siglo XIX a partir de un manuscrito del siglo XVIII. Col. Biblioteca conmemorativa Howard-Tilton, Universidad de Tulane.</p>
    <p>Tras la muerte de Moctezuma, Cortés y los ejércitos aliados salieron de Tenochtitlan para organizar nuevas acciones militares, después de ser atacados por las tropas del tlatoani Cuitláhuac, sucesor de Moctezuma.</p>
    <p>En octubre de 1520, Tenochtitlan y Tlatelolco sufrieron una terrible epidemia de viruela, teniendo entre sus víctimas a Cuitláhuac, por lo que toma el poder como nuevo tlatoani, Cuauhtémoc, primo de Moctezuma y líder militar de la resistencia mexica contra los españoles y aliados.</p>
    <p>Entre enero y abril de 1521 llegaron más tropas españolas y se establecieron alianzas con Texcoco, Chalco y otros pueblos en la periferia de Tenochtitlan. En mayo empezó un cerco militar que incluyó el ataque desde diferentes lugares: Tacuba, Coyoacán, Iztapalapa y Texcoco; mientras se corta el agua potable.</p>
    <p>Después de 75 días de ataque y resistencia, el 13 de agosto de 1521 se logró la captura de Cuauhtémoc, lo que significó la caída de Tlatelolco y Tenochtitlan a manos del ejército aliado comandado por Hernán Cortés. Estos acontecimientos marcaron el inicio de un largo proceso de guerras, ocupaciones y expansiones militares que denominamos: conquista de México.</p>
    <h5>VER MÁS</h5>
    <p>Aquí puedes ver el lienzo de Tlaxcala completo: 
      <ul>
        <li><a target="_blank" href="https://digitallibrary.tulane.edu/islandora/object/tulane%3A19311/datastream/PDF/view">digitallibrary.tulane.edu</a></li>
      </ul>
    </p>
    <h4>Los famosos bergantines</h4>
    <img @click="imageClicked(1)" src="galerias/tenochtitlan/g6/G6_a.png" class="mainphoto"/>
    <p class="photo-description">Códice Florentino. Fray Bernardino de Sahagún, 1577. Col. Biblioteca Laurenciana de Florencia.</p>
    <p>Una estrategia militar emprendida por el ejército español para la toma de Tenochtitlan fue la construcciones de 12 bergantines, pequeñas embarcaciones, que tenían la misión de atacar usando cañones.</p>
    <p>La construcción de estas naves se realizó en Tlaxcala, utilizando algunos elementos de las naves que Cortés había pedido que se desmantelaran en Veracruz.</p>
    <p>En el libro XII del Códice Florentino se registra este hecho de la siguiente manera, acompañado por la imagen que aquí se muestra: “Entonces decidieron comenzar los ataques por agua. Cortés había mandado labrar 12 bergantines en Tlaxcala, que sus aliados indígenas transportaron hasta Texcoco en donde los armaron, y con ellos comenzaron los ataques en Acachinanco, cerca de Tenochtitlan […] Por el lado de Tlatelolco también se inició la guerra en el agua”</p>
    <p>Ver más
      <ul>
        <li><a target="_blank" href="https://www.wdl.org/es/item/10623/view/1/115/">www.wdl.org</a></li>
      </ul>
    </p>
    <h4>Tlatelolco</h4>
    <img @click="imageClicked(2)" src="galerias/tenochtitlan/g6/G6_b.jpg" class="mainphoto"/>
    <p class="photo-description">Spamer's Otto, Das Alte Mexiko Und Die Groberung Reufpaniens/Ferdinand Cortes. Leipzig, 1865. Colección Particular</p>
    <p>Tlatelolco fue una ciudad fundada hacia 1337, por un grupo que separó de los tenochcas. Tlatelolco tuvo un desarrollo próspero, producto de las actividades comerciales. Cuando fue conquistado por los mexicas, el templo mayor tlatelolca fue destruído y la gran plaza ubicada frente a este, fue convertida en un mercado permanente, que en lengua náhuatl es nombrado tianguis. Su dimensión y actividad sorprendió a los conquistadores. Los tlatelolcas tuvieron una fuerte resistencia contra los ejércitos invasores.</p>
    <p>Conoce más de Tlatelolco en la siguiente galería: 
      <ul>
        <li><a target="_blank" href="https://www.flickr.com/photos/lahernandez/1468831792">www.flickr.com</a></li>
        <li><a target="_blank" href="https://www.noticonquista.unam.mx/index.php/imagen-popup/1025">www.noticonquista.unam.mx</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: "Sala1m6",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
